import React from 'react'

const DisplayError = ({error,fortagid}) => {
  return <> 
            {
             error?.map ( (err) => {
                if (err.tagid === fortagid){
                    return <div>
                        <small style={{color:'red', fontFamily: 'Inter', fontSize: '15px'}}> { err.errmsg } </small>
                     </div>
                }
             })
            }
         </>
}

export default DisplayError
